import { RootState } from '../../types/redux/states/RootState';

export const getLocale = ({ visitor }: RootState) => visitor?.locale;
